import { supabase } from './supabase';

export interface Admin {
  id:         number;
  username:   string;
  role:       'superadmin' | 'admin';
  is_active:  boolean;
  created_at: string;
  created_by: number | null;
}

export async function loginAdmin(username: string, password: string): Promise<Admin | null> {
  const { data, error } = await supabase
    .from('admins')
    .select('*')
    .eq('username', username.trim())
    .eq('password', password)
    .eq('is_active', true)
    .single();

  if (error || !data) return null;
  return data as Admin;
}

export async function getAllAdmins(): Promise<Admin[]> {
  const { data } = await supabase
    .from('admins')
    .select('id, username, role, is_active, created_at, created_by')
    .order('created_at', { ascending: false });
  return (data || []) as Admin[];
}

export async function createAdmin(
  username: string,
  password: string,
  createdBy: number
): Promise<{ success: boolean; error?: string }> {
  const { error } = await supabase.from('admins').insert({
    username: username.trim(),
    password,
    role: 'admin',
    created_by: createdBy,
  });
  if (error) return { success: false, error: error.message.includes('unique') ? 'Ce nom d\'utilisateur existe déjà.' : error.message };
  return { success: true };
}

export async function toggleAdminStatus(id: number, isActive: boolean): Promise<void> {
  await supabase.from('admins').update({ is_active: isActive }).eq('id', id);
}

export async function deleteAdmin(id: number): Promise<void> {
  await supabase.from('admins').delete().eq('id', id);
}

export async function changePassword(id: number, newPassword: string): Promise<{ success: boolean; error?: string }> {
  const { error } = await supabase.from('admins').update({ password: newPassword }).eq('id', id);
  if (error) return { success: false, error: error.message };
  return { success: true };
}
